import React from "react";

function ErrorSuccessMessage({ message, messageType, isActive, progress }) {
  return (
    <div className="noSpace  SuccessMessage-div ">
      {message && (
        <div className="successMessage ">
          {messageType === "success" ? (
            <div className="text-success noSpace ">
              <span className=" material-symbols-outlined verticalAlign">
                task_alt
              </span>
              <span className="ms-1 verticalAlign  "> {message} </span>
            </div>
          ) : (
            <div className="text-danger noSpace ">
              <span className="material-symbols-outlined verticalAlign ">
                error
              </span>
              <span className="ms-1 verticalAlign "> {message} </span>
            </div>
          )}

          <span className="ms-1 verticalAlign  ">
            {isActive && (
              <div
                className="circular-countdown"
                style={{ "--progress": progress }}
              ></div>
            )}
          </span>
        </div>
      )}
    </div>
  );
}

export default ErrorSuccessMessage;
